// src/components/SellingPoints/SellingPoints.js
import React from 'react';
import './SellingPoints.css';
import { FaIndustry, FaDollarSign, FaBoxes } from 'react-icons/fa';

const sellingPoints = [
  {
    icon: <FaIndustry size={32} />,
    title: "Massive Production Capacity",
    description:
      "Over 2 million sq. ft. of production space – that's around 30 football fields! We ship a minimum of 250 containers per month to meet your scaling needs.",
  },
  {
    icon: <FaDollarSign size={32} />,
    title: "Direct-from-Factory Advantage",
    description:
      "All products are manufactured 100% in-house. No middlemen. Just the best pricing, directly from us to you.",
  },
  {
    icon: <FaBoxes size={32} />,
    title: "Flexible & Scalable Supply",
    description:
      "Enjoy mixed container loading, and low MOQs on selected SKUs (as low as 1 unit) – perfect for market testing and varied orders.",
  },
];

const SellingPoints = () => {
  return (
    <section className="usp-section">
      <h2 className="usp-heading">Why Partner with Kozee?</h2>
      <div className="usp-cards">
        {sellingPoints.map((point, index) => (
          <div className="usp-card" key={index}>
            <div className="usp-icon">{point.icon}</div>
            <h3>{point.title}</h3>
            <p>{point.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SellingPoints;
